import {
  getBadgeContent,
  getBadgeTooltip,
  // @ts-ignore no types
} from '@adc/ui-adc'
import * as blueprint from '@adc/blueprint'
import { CombinedListingType } from 'common/context/listing'

export type BadgeVariant = Partial<blueprint.listing.ListingBadgeVariant>
export const mapBadgesToView = (
  badgeList: BadgeVariant[],
  listing: CombinedListingType,
  eventSubscriber: (ref: string) => void
): BadgeViewType[] =>
  badgeList.map((badge: BadgeVariant) => ({
    summary: badge.summary || '',
    // @ts-ignore id is in use
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    id: badge.id || '',
    contentPositive: badge.contentPositive,
    // TODO: remove as when toolkit is typed
    // @ts-ignore toolkit is not typed
    content: getBadgeContent(badge, listing, eventSubscriber) as JSX.Element, // eslint-disable-line
    icon: badge.titleIcon || '',
    title: badge.shouldBeHoisted ? badge.summary : badge.title,
    // TODO: remove as when toolkit is typed
    // @ts-ignore toolkit is not typed
    tooltipContent: getBadgeTooltip(badge) as JSX.Element, // eslint-disable-line
  }))

export interface BadgeViewType {
  content: string | JSX.Element
  icon: string
  id?: string
  contentPositive?: boolean
  title?: string
  summary: string
  tooltipContent?: JSX.Element
}
